import CultureTableService from "../../service/CultureTableService";

const newCulture = {
    code: null,
    la_culture: null,
    et_culture: null,
    en_culture: null,
    fi_culture: null,
    lt_culture: null,
    type: null,
    growth_phase_id: null,
    culture_type: null,
    level_0_growth_phase: 0
}

const initialState = {
    cultures: [],
    cultureTypes: [],
    availableCultureTypes: [],
    newCulture: {...newCulture}
}

export default {
    namespaced: true,
    state: {...initialState},
    actions: {
        async fetchCulture({commit}) {
            try {
                const resp = await CultureTableService.getCulture()
                if (resp.status === 200) {
                    commit('setCulture', resp.data)
                }
            } catch (e) {
                console.log(e)
            }
        },
        async editCulture({dispatch}, newData) {
            try {
                const resp = await CultureTableService.put(newData)
                if (resp.status === 200) {
                    dispatch('app/showSnackbar', {
                        bool: true,
                        message: 'Culture updated',
                        type: 'success'
                    }, {root: true})
                }
            } catch (e) {
                console.log(e)
            }
        },
        async deleteCulture({dispatch, commit}, recID) {
            try {
                const resp = await CultureTableService.delete(recID)
                if (resp.status === 200) {
                    commit('resetNewCulture')
                    dispatch('app/showSnackbar', {
                        bool: true,
                        message: 'Recommendation deleted',
                        type: 'success'
                    }, {root: true})
                }
            } catch (e) {
                console.log(e)
            }
        },
        async handleNewCultureClick({state, commit, dispatch}) {
            try {
                const resp = await CultureTableService.createCulture(state.newCulture)
                if (resp.status === 201) {
                    commit('resetNewCulture')
                    dispatch('app/showSnackbar', {
                        bool: true,
                        message: 'New culture created',
                        type: 'success'
                    }, {root: true})
                }
            } catch (e) {
                console.log(e)
            }
        }
    },
    mutations: {
        setTableData(state, data) {
            state.tableData = data
        },
        resetNewCulture(state) {
            state.newCulture = {}
        },
        setCulture(state, data){
            state.cultures = data.table_data
            state.cultureTypes = data.culture_types
            state.availableCultureTypes = data.available_culture_types || []
        },
        setNewCultureIndex(state, data) {
            state.newCulture.code = data.code
        }
    },
    getters: {
        getCulturesOrderedByCode(state) {
            /*
            * Sorts cultures by code, first by the letter and then by the number following the letter
            * */
            return state.cultures.sort((a, b) => {
                try {
                    const letterA = a.code.replace(/[0-9]*/g, '')
                    const numberA = parseInt(a.code.replace(/[a-zA-z]*/g, ''))
                    const letterB = b.code.replace(/[0-9]*/g, '')
                    const numberB = parseInt(b.code.replace(/[a-zA-z]*/g, ''))
                    return letterB > letterA || numberB - numberA
                } catch {
                    return 0
                }
            })
        },
        getNextCultureIndex(state, getters) {
            const orderedCultures = getters.getCulturesOrderedByCode
            let highestCultureCode = orderedCultures[0]?.code
            let lowestMissingNumber = parseInt(highestCultureCode.replace(/[a-zA-z]*/g, '')) + 1
            // find the first missing index
            for (let i=1; i<=orderedCultures.length; i++){
                const currentCultureCode = orderedCultures[(orderedCultures.length)-i]?.code
                const number = parseInt(currentCultureCode.replace(/[a-zA-z]*/g, ''))
                if (number !== i){
                    lowestMissingNumber = i
                    break
                }
            }
            try {
                const letter = highestCultureCode.replace(/[0-9]*/g, '')
                return `${letter}${lowestMissingNumber}`
            }
            catch {
                return ""
            }
        }
    }
}